import { loadMemberInit } from "@xinosolutions/xs-auth-react";
import { createLearnixProductApiConfig } from "../../config/learnixProductApi";

export const member_init_api = async (data, signal = null) => {
  void signal;
  return loadMemberInit(createLearnixProductApiConfig(), data || {});
};

export const member_session_api = async (signal = null) => {
  void signal;
  const { bootstrapProductSession } = await import("@xinosolutions/xs-auth-react");
  return bootstrapProductSession(createLearnixProductApiConfig());
};

export const update_user_region_api = async (data) => {
  const { invokeApi } = await import("../../bl_libs/invokeApi");
  return invokeApi({
    path: `api/general_routes/update_user_region`,
    method: "POST",
    postData: data,
  });
};

export const complete_onboarding_api = async (data) => {
  const { invokeApi } = await import("../../bl_libs/invokeApi");
  return invokeApi({
    path: `api/associates/complete_onboarding`,
    method: "POST",
    postData: data,
  });
};
